import React, { useRef } from 'react';
import { images } from '../../../Constants/ImageUrls';
import { ButtonContainer, GetOtpContainer, ImageContainer } from './styled';
import { fireClickedEvent } from '../utils';
import { createRippleEffectRelative } from '../../../Utils/helper';

function GetOtpButton(props) {
  const { disableSendButton, sendOtp, fromConsult } = props;
  const getOtpRef = useRef();
  const clickedOtpButton = (e) => {
    createRippleEffectRelative(e, getOtpRef.current);
    if (!disableSendButton) {
      fireClickedEvent('send_otp');
      sendOtp();
    }
  };
  return (
    <GetOtpContainer>
      <ImageContainer>
        <img src={images.backgroundLogin} alt="" />
      </ImageContainer>
      <ButtonContainer
        onClick={(e) => clickedOtpButton(e)}
        disableSendButton={disableSendButton}
        ref={getOtpRef}
        fromConsult={fromConsult}
      >
        GET OTP
      </ButtonContainer>
    </GetOtpContainer>
  );
}

export default GetOtpButton;
